<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.companies_approval") }}
      UiStackItem
        UiButton(
          @click="exportApprovalCompanies()"
          icon="FileDownload"
        ) {{ $t("companies.export_to_excel") }}
  UiCardSection
    RestTable(
      namespace="companies_approval"
      :headers="headers"
      ref="companiesApprovalTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem
            UiFormGroup(:label="$t('admin_users.company')")
              UiInput(
                :modelValue="filters.search"
                type="search"
                @update:modelValue="updateFilters({ search: $event })"
                inputSize="40"
              )
</template>
<script>
import router from "@/router";
import ApiCompanies from "@/api/companies.js";

export default {
  data() {
    return {
      initialFilters: {
        approval_flow_active: true, // always true
      },
      headers: [
        {
          key: "company_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "netvisor_organization_id",
          label: "Business ID",
          sortable: true,
        },
      ],
    };
  },

  methods: {
    getData(params, config) {
      return ApiCompanies.fetchCompanies(params, config).then((resp) => {
        return {
          items: resp.data.companies,
          meta: resp.data.meta,
        };
      });
    },
    exportApprovalCompanies() {
      ApiCompanies.exportApprovalCompanies(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `approval_companies.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
    goBack() {
      router.push("/companies");
    },
  },
};
</script>
